import axios from 'axios';
import { apiURL } from './settings.js'

const api = axios.create({ baseURL: apiURL });

export default api;